import { XCard, XPackBy } from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useViewingPlayerOpt } from "~/jsx/hook";
import { Sizes, Spacing } from "~/jsx/theme";
import { XDesignModal } from "../design/XDesignModal";

export const XDiscardModal = () => {
  const viewingPlayer = useViewingPlayerOpt();
  if (!viewingPlayer) return null;
  const { discard } = viewingPlayer;
  return (
    <XDesignModal name={ModalNames.discardCards} title={<>Discarded cards</>}>
      <XPackBy packSize={5} gap={Spacing.px8}>
        {discard.pile.map((card) => (
          <XCard
            key={card.id}
            card={card}
            width={Sizes.cardWidths.normal}
            removeAnimationId={true}
          />
        ))}
      </XPackBy>
    </XDesignModal>
  );
};
